import { Inject, Injectable } from '@angular/core';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

import { CUSTOM_AXIOS } from 'src/app/shared/common/utils/axios';
import { environment } from 'src/environments/environment';
import { formattedTodayYYYYMMDD } from '../../utils/formatters';
import { GlobalStorage } from '../globals.service';

import { DOCUMENT } from '@angular/common';
import { IStopSubscription } from 'src/app/shared/interfaces/stop.subscription.interface';

@Injectable({
  providedIn: 'root',
})
export class BffService {
  private customAxios: any;
  private token: any;

  constructor(
    public globalSvc: GlobalStorage,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.token = this.globalSvc.token;
    this.customAxios = CUSTOM_AXIOS;

    this.customAxios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${this.token}`;

    this.customAxios.defaults.headers.common['canal'] = (this.document.defaultView as any).Capacitor ? 'PWA' : 'WEB';
    this.customAxios.defaults.headers.common['origen'] = (this.document.defaultView as any).Capacitor ? 'PWA' : 'NUEVAWEB';
  }

  private setSvcToken(): void {
    this.token = this.globalSvc.token;
    this.customAxios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${this.token}`;
  }

  public getCurrentUf(): Promise<AxiosResponse<any, any>> {
    const today = `${formattedTodayYYYYMMDD()}T00:00:00`;
    const url = `${environment.BFF.BASE_URL}/subscription/uf?dateBegin=${today}&dateEnd=${today}`;

    return this.customAxios.get(url);
  }

  public getRentability(): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/rentability`;
    this.setSvcToken();
    return this.customAxios.get(url);
  }

  public getEmployersByRut(): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/employers`;
    return this.customAxios.get(url);
  }

  public getEmployerData(rut: string): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/employers/employer/data?employerRut=${rut}`;
    return this.customAxios.get(url);
  }

  public getActiveSubscriptions(): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/request/subscriptions/active`;
    this.setSvcToken();
    return this.customAxios.get(url);
  }

  public getContributions(): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/contributions`;
    return this.customAxios.get(url);
  }

  public submitSubscription(
    subscription: any
  ): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/request/apv`;
    return this.customAxios.post(url, subscription);
  }

  public modifySubscription(
    subscription: any,
    token: string
  ): Promise<AxiosResponse<any, any>> {
    this.getHeaders(token);
    const url = `${environment.BFF.BASE_URL}/subscription/request/modify/apv`;
    return this.customAxios.post(url, subscription);
  }

  public stopSubscription(
    data: IStopSubscription,
    token:string
  ): Promise<AxiosResponse<any, any>> {
    this.getHeaders(token)
    const url = `${environment.BFF.BASE_URL}/subscription/request/stop/apv`;
    return this.customAxios.post(url, data);
  }
  public modifyRegimenAccount(data: any, token: string): Promise<AxiosResponse<any, any>> {
    this.getHeaders(token);
    const url = `${environment.BFF.BASE_URL}/subscription/request/modify/regime/apv`;
    return this.customAxios.post(url, data);
  }
  public async generatePDF(data: any, templateName: string): Promise<any> {
    const url = `${environment.BFF.BASE_URL}/subscription/generate-pdf`;
    return this.customAxios.post(url, { datos: data, templateName });
  }

  public getUnfilteredSubscriptions(): Promise<AxiosResponse<any, any>> {
    const url = `${environment.BFF.BASE_URL}/subscription/request/subscriptions/active?filterByMovements=false`;
    this.setSvcToken();
    return this.customAxios.get(url);
  }

  private getHeaders(token: string) {

    const canal = (this.document.defaultView as any).Capacitor ?  'PWA': 'WEB';
    const origen = (this.document.defaultView as any).Capacitor ? 'PWA' : 'NUEVAWEB';
    this.customAxios = axios.create();
   
   this.customAxios.interceptors.request.use((config: AxiosRequestConfig) => {
     if (!config.headers) {
       config.headers = {};
     }
     config.headers['Authorization'] = `Bearer ${token}`;
     config.headers['canal'] = canal;
     config.headers['origen'] = origen;
     return config;
   })
 }
}
